import IValidationService from "features/validation/IValidationService";
import ValidationService from "features/validation/ValidationService";
import IValidationRuleService from "features/validation/IValidationRuleService";
import ValidationRuleService from "features/validation/ValidationRuleService";
import BankAccountValidator from 'features/validation/validators/BankAccountValidator';
import SipoValidator from 'features/validation/validators/SipoValidator';
import { ContainerModule, interfaces } from "inversify";
import { IocTypes } from "../ioc.types";
import FileValidator from "features/validation/validators/FileValidator";
import FileValidatorConfig from "features/validation/models/FileValidatorConfig";
import { loadModule } from "features/shared/helpers/modules";

const fileValidatorConfig = loadModule<FileValidatorConfig>("validators/fileValidator.json");

export const validationModule = new ContainerModule((bind: interfaces.Bind) => {
  bind<IValidationService>(IocTypes.ValidationService).to(ValidationService);
  bind<IValidationRuleService>(IocTypes.ValidationRuleService).to(ValidationRuleService).inSingletonScope();
  bind<BankAccountValidator>(IocTypes.BankAccountValidator).to(BankAccountValidator).inSingletonScope();
  bind<SipoValidator>(IocTypes.SipoValidator).to(SipoValidator).inSingletonScope();
  bind<FileValidator>(IocTypes.FileValidator).toConstantValue(new FileValidator(fileValidatorConfig));
});